function fn_layout_main() {
    var $body = $("body");

    setTimeout(function(){
        $body.removeClass("preload").addClass("loaded");
        setTimeout(function () {
            $body.removeClass("loaded");
        }, 500);
    }, 250);

    if($('body').is('[data-dialog-open]')) {
        $.ajax({
            dataType: "json",
            data: {ajax: +new Date},
            url: $('body').filter("[data-dialog-open]").data('dialog-open')
        }).done(function(data) {

        });
    }

    $(document).on('click','[data-go-back]',function() {
        $('body').html('');
        history.go(-1);
        return false;
    });

    $("[data-shipping-info]").on("click",function(e){
        e.preventDefault();
        $(this).toggleClass("active").closest(".cols").find(".status").fadeToggle(300);
    });

    $('[name="delivery"]').on('change', function(){
        var $elm = $(this);

        $elm.closest('fieldset').find('.status').hide();

        if($elm.prop('checked')) {
            $elm.closest(".cols").find(".status").fadeIn();
        }
    });

    var headroom = new Headroom(document.querySelector("#main-header"), {
        "offset": 30,
        "tolerance": 0,
        "classes": {
            "initial": "animated",
            "pinned": "slideDown",
            "unpinned": "slideUp"
        }
    });
    headroom.init();

    if ($("[data-custom-select]").length) {
        $("[data-custom-select]").each(function(){
            if ($(this).attr("data-custom-select") == "color") {
                function formatState (state) {
                    if (!state.id) { return state.text; }
                    var $state = $(
                        '<span class="color-item"><i class="color" style="background-color: '+$(state.element).data("color")+'"></i> <i>' + state.text + '</i></span>'
                    );
                    return $state;
                }
                $(this).select2({
                    templateResult: formatState,
                    templateSelection: formatState,
                    minimumResultsForSearch: Infinity
                });
            } else {
                $(this).select2({
                    minimumResultsForSearch: Infinity
                });
            }
        });
    }
}